import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "paper-design"
};
var _hoisted_2 = {
  class: "filter-bar"
};
var _hoisted_3 = {
  class: "filter-bar-left"
};
var _hoisted_4 = {
  class: "filter-bar-right"
};
var _hoisted_5 = {
  key: 0,
  class: "empty-box"
};
var _hoisted_6 = {
  key: 0,
  class: "paper-list"
};
var _hoisted_7 = {
  class: "list-scroll"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  class: "paper-content"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = {
  class: "paper-content-tags"
};
var _hoisted_13 = {
  key: 0,
  class: "tag"
};
var _hoisted_14 = ["id"];
var _hoisted_15 = ["onClick"];
var _hoisted_16 = ["onClick"];
var _hoisted_17 = {
  key: 0
};
var _hoisted_18 = {
  class: "paper-content-info"
};
var _hoisted_19 = {
  class: "paper-btns"
};
var _hoisted_20 = ["onClick"];
var _hoisted_21 = ["onClick"];
var _hoisted_22 = {
  class: "paper-list-page"
};
var _hoisted_23 = {
  key: 1,
  class: "empty-box"
};
import { MessagePlugin } from 'tdesign-vue-next';
import { SearchIcon } from 'tdesign-icons-vue-next';
import { onMounted, ref, toRaw } from 'vue';
import { getStore } from '@/util/store.js';
import { getExercisesPaperPage, practicePaperCite } from '@/api/index-bei';
import { getAppUrl, jumpEdit } from '@/util/inspirationCentre';
import PublishStep from './components/PublishStep.vue';
import { skipUrl as skipUrlOpen } from '@/util/util';
export default {
  __name: 'Paper',
  setup: function setup(__props) {
    var accessToken = getStore({
      name: 'access_token'
    });
    var inspirationCentre = ref('');
    var prepareLesson = ref('');
    var loading = ref(true);
    var getTopLinks = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getAppUrl('inspirationCentre');
            case 1:
              _t = _context.v;
              if (_t) {
                _context.n = 2;
                break;
              }
              _t = '';
            case 2:
              inspirationCentre.value = _t;
              _context.n = 3;
              return getAppUrl('prepareLesson');
            case 3:
              _t2 = _context.v;
              if (_t2) {
                _context.n = 4;
                break;
              }
              _t2 = '';
            case 4:
              prepareLesson.value = _t2;
            case 5:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getTopLinks() {
        return _ref.apply(this, arguments);
      };
    }();
    var timeSort = ref('desc');
    var toggleTimeSort = function toggleTimeSort() {
      timeSort.value = timeSort.value === 'desc' ? 'asc' : 'desc';
      getList();
    };
    var searchKey = ref('');
    var currentPage = ref(1);
    var pageSize = ref(20);
    var total = ref(0);
    var onPageSizeChange = function onPageSizeChange(size) {
      pageSize.value = size;
      getList();
    };
    var onChange = function onChange(pageInfo) {
      currentPage.value = pageInfo.current;
      getList();
    };
    var paperList = ref([]);
    var getList = function getList() {
      loading.value = true;
      var params = {
        size: pageSize.value,
        current: currentPage.value,
        updateTimeSort: timeSort.value === 'desc' ? 0 : 1,
        selectText: searchKey.value
      };
      getExercisesPaperPage(params).then(function (res) {
        console.log('getExercisesPaperPage', res);
        if (res.data.code === 0) {
          paperList.value = res.data.data.records;
          total.value = res.data.data.total;
        }
      }).finally(function () {
        loading.value = false;
      });
    };
    var handleSearch = function handleSearch() {
      currentPage.value = 1;
      getList();
    };
    var refreshList = function refreshList() {
      getList();
    };
    var handleCreatePaper = function handleCreatePaper() {
      if (inspirationCentre.value) {
        var url = "".concat(inspirationCentre.value, "?inspirationCentre=%2Fsub-inspiration-centre-svc%2FchoiseExercise&token=").concat(accessToken);
        window.open(url);
      } else {
        MessagePlugin.warning('暂无应用权限！');
      }
    };
    var handleViewPaper = function handleViewPaper(resId) {
      if (inspirationCentre.value) {
        // https://preweb.zhixuehuijiao.cn/inspirationCentre?inspirationCentre=/sub-inspiration-centre-svc/previewParper?resId=1838485703541755905
        var url = "".concat(inspirationCentre.value, "?inspirationCentre=%2Fsub-inspiration-centre-svc%2FpreviewParper&resId=").concat(resId, "&token=").concat(accessToken);
        window.open(url);
      } else {
        MessagePlugin.warning('暂无应用权限！');
      }
    };

    /**
     * 关联数据展示
     * @param item
     */
    var tooltipActive = ref([]);
    var linkedData = function linkedData(item) {
      setTimeout(function () {
        item.focus = true;
      }, 50);
      var citeResTypeText = function citeResTypeText(type) {
        return type === 0 ? '课程' : type === 1 ? '学程' : '习练';
      };
      tooltipActive.value = item.commonResCites.map(function (_item) {
        return {
          citeResType: _item.citeResType,
          resType: citeResTypeText(_item.citeResType),
          resName: _item.name,
          resId: _item.citeResId,
          id: _item.id,
          practiceId: item.resId
        };
      });
    };
    var publishVisible = ref(false);
    var currentPublishPaper = ref(null);
    var getPublishPermission = function getPublishPermission(paper) {
      return inspirationCentre.value;
    };
    var handlePublish = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(paper) {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (inspirationCentre.value) {
                _context2.n = 1;
                break;
              }
              MessagePlugin.warning('暂无应用权限，无法发布习练！');
              return _context2.a(2);
            case 1:
              if (!(!inspirationCentre.value && paper.preStatus === 0)) {
                _context2.n = 2;
                break;
              }
              MessagePlugin.warning('暂无备课应用权限，无法发布习练！');
              return _context2.a(2);
            case 2:
              console.log('handlePublish', toRaw(paper));
              if (!(paper.preStatus === 0)) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return practicePaperCite(paper.id);
            case 3:
              res = _context2.v;
              if (res.data.code === 0) {
                paper.preStatus = 1;
                console.log('已发送至备课');
                currentPublishPaper.value = paper;
                publishVisible.value = true;
              }
              _context2.n = 5;
              break;
            case 4:
              console.log('已经在备课中，直接发布');
              currentPublishPaper.value = paper;
              publishVisible.value = true;
            case 5:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function handlePublish(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var handlePublishClose = function handlePublishClose(data) {
      if (data === 'success') {
        refreshList();
      }
      currentPublishPaper.value = null;
      publishVisible.value = false;
    };
    var handleEdit = function handleEdit(paper) {
      if (!inspirationCentre.value) {
        MessagePlugin.warning('暂无应用权限！');
        return;
      }
      var url = "".concat(inspirationCentre.value, "?inspirationCentre=%2Fsub-inspiration-centre-svc%2FeditParper%3FresId%3D").concat(paper.resId, "&token=").concat(accessToken);
      window.open(url);
    };
    var handleInspiration = function handleInspiration() {
      if (inspirationCentre.value) {
        var url = "".concat(inspirationCentre.value, "?inspirationCentre=%2Fsub-inspiration-centre-svc%2Fpractice&token=").concat(accessToken);
        skipUrlOpen(url);
      } else {
        MessagePlugin.warning('暂无备课应用权限！');
      }
    };
    onMounted(function () {
      getTopLinks();
      getList();
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_loading = _resolveComponent("t-loading");
      var _component_t_popup = _resolveComponent("t-popup");
      var _component_t_tooltip = _resolveComponent("t-tooltip");
      var _component_t_pagination = _resolveComponent("t-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass(['btn-sort', timeSort.value]),
        onClick: toggleTimeSort
      }, [_cache[3] || (_cache[3] = _createTextVNode(" 编辑时间", -1)), _createVNode(_component_svg_icon, {
        class: "icon-order",
        name: "course-order",
        size: "16"
      })], 2), _createVNode(_component_t_input, {
        modelValue: searchKey.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return searchKey.value = $event;
        }),
        placeholder: "请输入内容"
      }, {
        suffixIcon: _withCtx(function () {
          return [_createVNode(_unref(SearchIcon), {
            style: {
              cursor: 'pointer'
            },
            onClick: handleSearch
          })];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "btn-refresh",
        onClick: refreshList
      }, [_cache[4] || (_cache[4] = _createTextVNode(" 刷新", -1)), _createVNode(_component_svg_icon, {
        class: "icon-refresh",
        name: "course-refresh",
        size: "16"
      })]), _createElementVNode("div", {
        class: _normalizeClass(['btn-create', {
          disabled: !inspirationCentre.value
        }]),
        onClick: handleInspiration
      }, [_createVNode(_component_svg_icon, {
        class: "icon-create",
        name: "prepare-icon",
        size: "16"
      }), _cache[5] || (_cache[5] = _createTextVNode("前往备课 ", -1))], 2), _createElementVNode("div", {
        class: _normalizeClass(['btn-create', {
          disabled: !inspirationCentre.value
        }]),
        onClick: handleCreatePaper
      }, [_createVNode(_component_svg_icon, {
        class: "icon-create",
        name: "course-paper",
        size: "16"
      }), _cache[6] || (_cache[6] = _createTextVNode("创建习练 ", -1))], 2)])]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_t_loading, {
        text: "数据加载中...",
        size: "small"
      })])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [paperList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paperList.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "paper-list-item"
        }, [_createElementVNode("div", {
          class: "paper-cover",
          onClick: function onClick($event) {
            return handleViewPaper(item.resId);
          }
        }, [_createElementVNode("img", {
          src: item.cover
        }, null, 8, _hoisted_9)], 8, _hoisted_8), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
          onClick: function onClick($event) {
            return handleViewPaper(item.resId);
          },
          class: "paper-content-title"
        }, _toDisplayString(item.title), 9, _hoisted_11), _createElementVNode("div", _hoisted_12, [item.pubStatus === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_13, "已发布")) : _createCommentVNode("", true), item.commonResCites && item.commonResCites.length > 0 ? (_openBlock(), _createBlock(_component_t_tooltip, {
          key: 1
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_t_popup, {
              trigger: "click",
              placement: "right",
              hideEmptyPopup: "",
              showArrow: "",
              attach: '#myPopup' + item.id
            }, {
              content: _withCtx(function () {
                return [_cache[8] || (_cache[8] = _createTextVNode(" 已关联 ", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tooltipActive.value, function (_item, index) {
                  return _openBlock(), _createElementBlock("span", {
                    key: index
                  }, [_createElementVNode("span", null, _toDisplayString(_item.resType) + "“" + _toDisplayString(_item.resName) + " ID ", 1), _createElementVNode("span", {
                    style: {
                      "color": "#5eb0ff",
                      "cursor": "pointer"
                    },
                    onClick: function onClick($event) {
                      return _unref(jumpEdit)(_item);
                    }
                  }, _toDisplayString(_item.id), 9, _hoisted_16), _cache[7] || (_cache[7] = _createTextVNode("” ", -1)), index < tooltipActive.value.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_17, "、")) : _createCommentVNode("", true)]);
                }), 128))];
              }),
              default: _withCtx(function () {
                return [_createElementVNode("div", {
                  class: "myPopup",
                  id: 'myPopup' + item.id
                }, [_createElementVNode("span", {
                  class: "tag relevance",
                  onClick: function onClick($event) {
                    return linkedData(item);
                  }
                }, "已关联", 8, _hoisted_15)], 8, _hoisted_14)];
              }),
              _: 2
            }, 1032, ["attach"])];
          }),
          _: 2
        }, 1024)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("span", null, "编辑时间: " + _toDisplayString(item.updateTime), 1), _createElementVNode("span", null, "创编人: " + _toDisplayString(item.authorName), 1), _createElementVNode("span", null, "原创人: " + _toDisplayString(item.originalUserName ? item.originalUserName : item.originalName), 1)])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
          class: _normalizeClass(['paper-btns-item', {
            disabled: !getPublishPermission(item)
          }]),
          onClick: function onClick($event) {
            return handlePublish(item);
          }
        }, " 发布 ", 10, _hoisted_20), _createElementVNode("div", {
          class: _normalizeClass(['paper-btns-item', {
            disabled: !inspirationCentre.value
          }]),
          onClick: function onClick($event) {
            return handleEdit(item);
          }
        }, "编辑", 10, _hoisted_21)])]);
      }), 128))]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_t_pagination, {
        modelValue: currentPage.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return currentPage.value = $event;
        }),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = function ($event) {
          return pageSize.value = $event;
        }),
        total: total.value,
        "show-jumper": "",
        pageSizeOptions: [20, 50, 100, 200, 500],
        onChange: onChange,
        onPageSizeChange: onPageSizeChange
      }, null, 8, ["modelValue", "pageSize", "total"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_svg_icon, {
        name: "empty-content",
        size: "120",
        class: "icon"
      })]))], 64)), publishVisible.value ? (_openBlock(), _createBlock(PublishStep, {
        key: 2,
        "publish-visible": publishVisible.value,
        paper: currentPublishPaper.value,
        onClose: handlePublishClose
      }, null, 8, ["publish-visible", "paper"])) : _createCommentVNode("", true)]);
    };
  }
};